import { AuthService } from './auth.service';
const ɵ0 = window.location, ɵ1 = (authService) => () => authService.initAuth();
export class AuthModule {
}
export { ɵ0, ɵ1 };
